












































import _ from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';

import { Setting as mainTerms} from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms} from '@/const/terms/componentTerms';
import { EditAdvertiser as feedbackTerms } from '@/const/terms/feedback/advertiser';

import { STATUS } from '@/const/status';
import { FormType } from './editingTypes';

import { Form as ElForm } from 'element-ui';
import { AxiosError, AxiosResponse } from 'axios';

@Component<AdvertiserEdit>({
    name: 'AdvertiserEdit',
    beforeRouteLeave (to: any, from: any, next: any) {
        if (this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    }
})
export default class AdvertiserEdit extends Vue {
    private terms = mainTerms;
    private compTerms = compTerms;
    
    private isSubmit: boolean = false;
    private loading: boolean = false;
    private subLoading: number = 0;
    private form: FormType = {
        no: undefined,
        name: '',
        description: '',
    }

    get whichLocation() {
        return this.$route.path.split('/').splice(-1, 1)[0].toLowerCase();
    }
    get isEdit() {
        return (this.$route.params && this.$route.params.advertiserID && true) === true;
    }
    private cancelForm() {
        this.$router.push({name: 'advertiser'});
    }
    private validateForm() {
        const form = this.$refs.form as ElForm;
        form.validate().then((valid: boolean) => {
            if (valid) {
                if (this.isEdit) {
                    this.submitForEdit(form.model as FormType).then((res: any) => res.data)
                        .then((data: {result: boolean}) => {
                            if (data && data.result) {
                                this.$notify.success(feedbackTerms.editing.success);
                                this.isSubmit = true;
                                this.$router.push({name: 'advertiser'});
                                return;
                            }
                            throw new Error(feedbackTerms.editing.error.fail);
                        })
                        .catch((err: AxiosError) => {
                            if (err.response && (err.response as AxiosResponse).status !== 200) {
                                this.$notify.error(feedbackTerms.editing.error.fail);
                            } else {
                                this.$notify.error(err.message);
                            }
                            throw err;
                        })
                        .finally(() => {this.loading=false});
                } else {
                    this.submitForNew(form.model as FormType).then((res: any) => res.data)
                        .then((data: boolean) => {
                            if (data) {
                                this.$notify.success(feedbackTerms.new.success);
                                this.isSubmit = true;
                                this.$router.push({
                                    name: 'advertiser'
                                });
                            }
                        })
                        .catch((err: AxiosError) => {
                            if (err.response && (err.response as AxiosResponse).status !== 200) {
                                this.$notify.error(feedbackTerms.new.error.fail);
                            } else {
                                this.$notify.error(err.message);
                            }
                            throw err;
                        })
                        .finally(()=>{this.loading=false});
                }
            } else {
                return false;
            }
        }).catch((err: boolean) => {
            if (err === false) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;
                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;
                    el.focus();
                }
            }
        })
    }


    private submitForEdit(model: FormType) {
        return this.$http.adserverAPI.post('UpdateAdvCompanyInfo', {
            adv_company_no:  model.no,
            adv_company_name: model.name.trim(),
            status: STATUS.ACTIVE,
            company_desc: model.description.trim(),
        })
    }
    // private submitForEdit(model: FormType) {return Promise.resolve(JSON.parse(JSON.stringify(true)))}
    private submitForNew(model: FormType) {
        return this.$http.adserverAPI.post('CreateAdvCompany', {
            adv_company_name: model.name.trim(),
            status: STATUS.ACTIVE,
            company_desc: model.description.trim(),
        });
    }
    // private submitForNew(model: FormType) {return Promise.resolve(JSON.parse(JSON.stringify(true)))}

    private getAdvertiserInfo() {
        return this.$http.adserverAPI.post('GetAdvCompanyInfo', {
            adv_company_no: this.$route.params.advertiserID,
        });
    }

    private async created() {
        if (this.isEdit) { // 수정
            this.loading = true;
            await this.getAdvertiserInfo().then((res: any) => res.data)
                .then((data: FormType) => {
                    if (data && (data as any).result === null) {
                        throw new Error(feedbackTerms.editing.error.notFound);
                    }
                    this.form = data;
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.editing.error.getAdvertiserInfo);
                    } else {
                        this.$notify.error(err.message);
                        this.isSubmit = true;
                        this.$router.push({ name: 'advertiser' });
                    }
                    throw err;
                })
                .finally(()=>{
                    this.loading = false;
                })
        }
    }
}
